import { useMutation, useQuery } from "@tanstack/react-query";
import client from "./client";
import { useNotifications } from "reapop";
import { queryClient } from "queryclient";
import { useNavigate } from "react-router-dom";

export const CreateChemistryBannerMutation = () => {
  const { notify } = useNotifications();
  const chemistryBanner = useMutation({
    mutationFn: (data) =>
      client.chemistryExpertise.createChemistryExpertiseBanner(data),
    onSuccess: () => {
      notify("Details Added Successfully", "success");
      queryClient.invalidateQueries({ queryKey: ["get-chemistry-banner"] });
    },

    onError: () => notify("OOPS! some error occured", "error"),
  });
  return chemistryBanner;
};

export const GetChemistryBannerMutation = () => {
  const chemistryBanner = useQuery({
    queryKey: ["get-chemistry-banner"],
    queryFn: () => client.chemistryExpertise.getChemistryExpertiseBanner(),
  });
  return chemistryBanner;
};

export const GetChemistryTabsMutation = () => {
  const chemistryTabs = useQuery({
    queryKey: ["get-all-chemistry-tabs"],
    queryFn: () => client.chemistryExpertise.getAllChemistryTabs(),
  });
  return chemistryTabs;
};

export const GetSingleChemistryTabsMutation = (data) => {
  const chemistryTabs = useQuery({
    queryKey: ["get-single-chemistry-tabs"],
    queryFn: () => client.chemistryExpertise.singleChemistryTabs(data),
  });
  return chemistryTabs;
};

export const CreateChemistryTabsMutation = () => {
  const { notify } = useNotifications();
  const navigate = useNavigate();
  const chemistryTabs = useMutation({
    mutationFn: (data) => client.chemistryExpertise.createChemistryTabs(data),
    onSuccess: () => {
      notify("Data Added Successfully", "success");
      navigate("/chemistry-tabs");
      queryClient.invalidateQueries({ queryKey: ["get-all-chemistry-tabs"] });
    },

    onError: () => notify("OOPS! some error occured", "error"),
  });
  return chemistryTabs;
};

export const EditChemistryTabsMutation = () => {
  const { notify } = useNotifications();
  const navigate = useNavigate();
  const chemistryTabs = useMutation({
    mutationFn: (data) => client.chemistryExpertise.updateChemistryTabs(data),
    onSuccess: () => {
      notify("Data Updated Successfully", "success");
      navigate("/chemistry-tabs");
      queryClient.invalidateQueries({ queryKey: ["get-all-chemistry-tabs"] });
    },

    onError: () => notify("OOPS! some error occured", "error"),
  });
  return chemistryTabs;
};

export const DeleteChemistryTabsMutation = () => {
  const { notify } = useNotifications();
  const chemistryTabs = useMutation({
    mutationFn: (data) => client.chemistryExpertise.deleteChemistryTabs(data),
    onSuccess: () => {
      notify("Data Deleted Successfully", "success");
      queryClient.invalidateQueries({ queryKey: ["get-all-chemistry-tabs"] });
    },

    onError: () => notify("OOPS! some error occured", "error"),
  });
  return chemistryTabs;
};

export const GetChemExpertiseExploreHeading = () => {
  return useQuery({
    queryKey: ["get-chem-expertise-explore-heading"],
    queryFn: () => client.chemistryExpertise.getChemExpertiseExploreHeading(),
  });
};

export const UpdateChemExpertiseExploreHeading = () => {
  const { notify } = useNotifications();
  return useMutation({
    mutationFn: (data) => client.chemistryExpertise.updateChemExpertiseExploreHeading(data),
    onSuccess: () => {
      notify("Heading updated successfully", "success");
      queryClient.invalidateQueries({ queryKey: ["get-chem-expertise-explore-heading"] });
    },
    onError: () => notify("OOPS! some error occurred", "error"),
  });
};

export const GetAllChemExpertiseExploreLinks = () => {
  return useQuery({
    queryKey: ["get-all-chem-expertise-explore-links"],
    queryFn: () => client.chemistryExpertise.getAllChemExpertiseExploreLinks(),
  });
};

export const CreateChemExpertiseExploreLink = () => {
  const { notify } = useNotifications();
  return useMutation({
    mutationFn: (data) => client.chemistryExpertise.newChemExpertiseExploreLink(data),
    onSuccess: () => {
      notify("Link added successfully", "success");
      queryClient.invalidateQueries({ queryKey: ["get-all-chem-expertise-explore-links"] });
    },
    onError: () => notify("OOPS! some error occurred", "error"),
  });
};

export const UpdateChemExpertiseExploreLink = () => {
  const { notify } = useNotifications();
  return useMutation({
    mutationFn: (data) => client.chemistryExpertise.updateChemExpertiseExploreLink(data),
    onSuccess: () => {
      notify("Link updated successfully", "success");
      queryClient.invalidateQueries({ queryKey: ["get-all-chem-expertise-explore-links"] });
    },
    onError: () => notify("OOPS! some error occurred", "error"),
  });
};

export const DeleteChemExpertiseExploreLink = () => {
  const { notify } = useNotifications();
  return useMutation({
    mutationFn: (data) => client.chemistryExpertise.deleteChemExpertiseExploreLink(data),
    onSuccess: () => {
      notify("Link deleted successfully", "success");
      queryClient.invalidateQueries({ queryKey: ["get-all-chem-expertise-explore-links"] });
    },
    onError: () => notify("OOPS! some error occurred", "error"),
  });
};
